<template>
  <div class="project-toggle">
    <button
      :class="{ '-active': currentView === ProjectView.Raster }"
      class="button button-simple"
      @click="emit('toggle', ProjectView.Raster)"
    >
      {{ general?.projectOverviewGridView }}
    </button>
    <span class="divider"> / </span>
    <button
      :class="{ '-active': currentView === ProjectView.List }"
      class="button button-simple"
      @click="emit('toggle', ProjectView.List)"
    >
      {{ general?.projectOverviewListView }}
    </button>
  </div>
</template>

<script setup lang="ts">
import type { GeneralFragment } from '#gql';

enum ProjectView {
  List = 'list',
  Raster = 'raster'
}

const props = defineProps<{
  currentView: ProjectView;
}>();

const general = inject<GeneralFragment>('general');

const emit = defineEmits<{
  (e: 'toggle', view: ProjectView): void;
}>();
</script>

<style scoped lang="scss">
.project-toggle {
  @media (--vs) {
    padding-top: 3.5rem;
    padding-bottom: 0.75rem;
    margin-bottom: 1.25rem;
    z-index: 10;
  }

  > .button,
  > .divider {
    @media (--vs) {
      @include text-xl(700);
    }

    @media (--vl) {
      @include text-md(700);
    }
  }
}
</style>
